import React from "react";
import styles from "./SelectionToolbar.module.css";

export default function SelectionToolbar({
  count = 0,
  onClear,
  onDelete,
  onEdit,
  onBulkEdit,
  onCopy,
  busy = false,
  /* NEW: pairing wizard-lite */
  canConvertToTransfer = false,
  onConvertToTransfer,
}) {
  if (!count) return null;

  const single = count === 1;
  const many = count > 1;

  const handleDeleteClick = async () => {
    const ok = window.confirm(
      `Delete ${count} selected item${count > 1 ? "s" : ""}? This cannot be undone.`
    );
    if (!ok) return;
    await onDelete?.();
  };

  return (
    <div
      className={`d-flex align-items-center flex-wrap gap-2 ${styles.wrap}`}
      role="region"
      aria-label="Selection actions"
    >
      <span className={`badge bg-secondary ${styles.countBadge}`} aria-live="polite">
        {count}
      </span>
      <span className={`text-secondary me-2 ${styles.selectedLabel}`}>selected</span>

      <div className="vr d-none d-sm-block" />

      {single && (
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={onEdit}
          disabled={busy || !onEdit}
          title="Edit selected item"
        >
          Edit
        </button>
      )}

      {many && (
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={onBulkEdit || onEdit}
          disabled={busy || !(onBulkEdit || onEdit)}
          title={`Bulk edit ${count} items`}
        >
          Bulk Edit
        </button>
      )}

      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={onCopy}
        disabled={busy || !onCopy}
        title="Duplicate selection (date set to today)"
      >
        {busy ? "Copying…" : "Copy"}
      </button>

      {/* NEW: Convert two singles → transfer (only shows when eligible) */}
      {canConvertToTransfer && (
        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          onClick={onConvertToTransfer}
          disabled={busy || !onConvertToTransfer}
          title="Pair selected rows into a single transfer"
        >
          Make Transfer
        </button>
      )}

      <button
        type="button"
        className="btn btn-sm btn-outline-danger"
        onClick={handleDeleteClick}
        disabled={busy || !onDelete}
        title="Delete selected"
      >
        {busy ? "Deleting…" : "Delete"}
      </button>

      <button
        type="button"
        className={`btn btn-sm btn-link text-decoration-none ${styles.clearLink}`}
        onClick={onClear}
        disabled={busy || !onClear}
        title="Clear selection"
      >
        Clear selection
      </button>
    </div>
  );
}
